export default {
  mounted() {
    this.observer = new IntersectionObserver(entries => {
      const entry = entries[0];
      if (entry.isIntersecting) {
        // console.log("Intersecting");
        // this.pushEventTo(this.el, "load-more", {});
      }
    }, { threshold: 0.1 });

    this.observer.observe(this.el.querySelector(".scroll-trigger"));
  },
  destroyed() {
    this.observer.disconnect();
  }
}
